import { Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";
import cardStyles from "@/components/summaryCard/summaryCard.module.css";
import styles from "@/components/backgroundTasks/backgroundTaskStartedNotice.module.css";

interface Props {
  message: string;
  hint?: string;
}

export default function BackgroundTaskStartedNotice({ message, hint }: Props) {
  return (
    <section className={cardStyles.card}>
      <div className={cardStyles.header}>
        <span className={cardStyles.iconContainer} aria-hidden="true">
          <RocketLaunchOutlinedIcon />
        </span>
        <Typography className={styles.message}>{message}</Typography>
      </div>
      {hint && (
        <div className={styles.hint}>
          <InfoOutlinedIcon className={styles.hintIcon} aria-hidden="true" />
          <Typography className={styles.hintText}>{hint}</Typography>
        </div>
      )}
    </section>
  );
}
